'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _camelToKebab = require('./camelToKebab.filter');

var _camelToKebab2 = _interopRequireDefault(_camelToKebab);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var camelToKebabModule = _angular2.default.module('camelToKebab.filter', []).filter('camelToKebab', _camelToKebab2.default).name;

exports.default = camelToKebabModule;


// WEBPACK FOOTER //
// ./client/app/common/filters/camelToKebabService/camelToKebab.js